export enum FunctionalUnit {
  KG = "KG",
  PORTION = "PORTION",
}
